export const testData = {
    search: '',
    resourceStrings: {
        fundName: 'Fund name',
        overview: 'Overview',
        series: 'Series',
        currency: 'Currency',
        fundAssets: 'Fund assets',
        _$Price: '$ Price',
        _$Change: '$ Change',
        MER: 'MER',
        riskRating: 'Risk',
        performance: 'Performance',
        dailyPerformance: 'Daily Performance',
        dailyPrices: 'Daily prices',
        ratings: 'Ratings',
        fundCodes: 'Fund codes',
        compoundPerformance: 'Compound Performance',
        documents: 'Documents',
        shortTerm: 'Short Term',
        longTerm: 'Long Term',
        overall: 'Overall',
        _1Yr: '1yr',
        _3Yr: '3yr',
        _5Yr: '5yr',
        _10Yr: '10yr',
        _1Mo: '1mo',
        _3Mo: '3mo',
        _6Mo: '6mo',
        _YTD: 'YTD',
        category: 'Category',
        percentChange: '% Change',
        FE: 'FE',
        DSC: 'DSC',
        CB: 'CB',
        LSC: 'LSC',
        ISC: 'ISC',
        assetClass: 'Asset Class',
        SD: 'SD',
        NL: 'NL',
        seriesFilterDefaultValue: 'F',
        currencyFilterDefaultValue: 'CAD',
        psi: 'Since inception',
        CUR: 'CUR',
        prefix: 'Prefix',
        pricesPerformance: 'Prices and performance',
        asOf: 'As of',
        nullGuard: 'N/A',
        fundAssetsExcel: 'Fund assets ($ in Millions)',
        merExcel: 'MER (%)',
        changeUpDownExcel: 'Change (up/down)',
        priceExcel: 'Price ($)',
        change$Excel: 'Change ($)',
        changePctExcel: 'Change (%)',
        inceptionDateExcel: 'Inception date (yyyy-mm-dd)',
        overallRating: 'Overall rating',
        overallFundsRated: 'Overall funds rated',
        '3yrRating': '3yr rating',
        '3yrFundsRated': '3yr funds rated',
        '5yrRating': '5yr rating',
        '5yrFundsRated': '5yr funds rated',
        '10yrRating': '10 yr rating',
        '10yrFundsRated': '10 yr funds rated',
        assetClassDefaultValue: 'all',
        locale: 'en-US',
        allocations: 'allocations',
        header: 'Header',
        price: 'Price',
    },
    queryStringParams: '',
    lang: 'en',
    colorPallete: [],
    locale: 'en-US',
    webProfiles: [
        {
            entityId: 'MBEGAA-CAD',
            sortOrder: null,
            isInactive: null,
            overview: {
                fundName: 'Sun Life MFS Canadian Equity Fund',
                seriesName: 'Series A',
                webProfileFundName: null,
                seriesShortName: 'A',
                seriesSortOrder: 80,
                aum: 979292980.32,
                riskRatingName: 'Low to medium',
                riskRating: {
                    entityId: '2',
                    name: 'Low to medium',
                    sortOrder: '002',
                },
                assetClass: 'Canadian Equity',
                assetClassSortOrder: 10,
                cifscCategory: 'Canadian Focused Equity',
                fundCategoryName: 'Equity',
                fundCategory: {
                    entityId: '1',
                    name: 'Equity',
                    shortName: null,
                    fullName: null,
                    sortOrder: null,
                },
                inceptionDate: '2009-03-31',
                mer: 0.0218,
                currency: 'CAD',
                fundCodes: {
                    isc: 'SUN166',
                    dsc: 'SUN266',
                    lsc: 'SUN366',
                },
                productName: 'No Product',
                productGroupSortOrder: 0,
            },
            performance: {
                dailyPerformance: {
                    effectiveDate: '2023-01-17',
                    navPS: 63.6997,
                    price: null,
                    d1EffectiveDate: '2023-01-16',
                    d1NavPs: 63.5066,
                    d1Amt: 0.1931,
                    d1Pct: 0.0030406288480252447,
                    d1Price: null,
                },
                effectiveDate: '2022-12-31',
                compoundPerformance: {
                    effectiveDate: '2022-12-31',
                    p1mo: -0.0537102996197971,
                    p3mo: 0.0593500501616948,
                    p6mo: 0.0486321482631026,
                    pytd: -0.0981079872574879,
                    p1yr: -0.0981079872574879,
                    p2yr: 0.03326118701819,
                    p3yr: 0.05198126279915,
                    p4yr: 0.08763609295023,
                    p5yr: 0.05752406789492,
                    p7yr: 0.06804934733293,
                    p8yr: 0.06121775237924,
                    p9yr: 0.06663957549706,
                    p10yr: 0.07978091634635,
                    psi: 0.0786397848933482,
                    psiB1: null,
                    psiB2: null,
                    psiB3: null,
                    best3mo: 0.208504491835978,
                    best3moEffectiveDate: '2009-06-30',
                    worst3mo: -0.186556990375824,
                    worst3moEffectiveDate: '2011-09-30',
                },
            },
            morningStarSeriesRatings: {
                overAllRating: {
                    rating: 3,
                    numFund: 540,
                },
                _1moRating: {
                    rating: null,
                    numFund: null,
                },
                _3moRating: {
                    rating: null,
                    numFund: null,
                },
                _6moRating: {
                    rating: null,
                    numFund: null,
                },
                _1yrRating: {
                    rating: null,
                    numFund: 555,
                },
                _3yrRating: {
                    rating: 3,
                    numFund: 540,
                },
                _5yrRating: {
                    rating: 3,
                    numFund: 495,
                },
                _10yrRating: {
                    rating: 3,
                    numFund: 321,
                },
                effectiveDate: '2022-12-31',
            },
            relatedDocuments: [
                {
                    entityId: 'MBEGAA-CAD-FF',
                    code: 'FF',
                    name: 'Fund Facts',
                    shortName: 'Fund Facts',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-prod-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-prod-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-sit-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-sit-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-staging-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-FP-staging-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-MRFP',
                    code: 'MRFP',
                    name: 'Management Reports of Fund Performance',
                    shortName: 'MRFP',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-prod-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-prod',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-sit-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: 'https://www.sunlifeglobalinvestments.com/en/products/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-sit',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-staging-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-PC-staging',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-Prospectus',
                    code: 'Prospectus',
                    name: 'Simplified Prospectus and Annual Information Form',
                    shortName: 'Prospectus',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGAA-CAD-QPD',
                    code: 'QPD',
                    name: 'Quarterly Portfolio Disclosure',
                    shortName: 'QPD',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
            ],
        },
        {
            entityId: 'MBEGF-CAD',
            sortOrder: null,
            isInactive: null,
            overview: {
                fundName: 'Sun Life MFS Canadian Equity Fund',
                seriesName: 'Series F',
                webProfileFundName: null,
                seriesShortName: 'F',
                seriesSortOrder: 10,
                aum: 979292980.32,
                riskRatingName: 'Low to medium',
                riskRating: {
                    entityId: '2',
                    name: 'Low to medium',
                    sortOrder: '002',
                },
                assetClass: 'Canadian Equity',
                assetClassSortOrder: 10,
                cifscCategory: 'Canadian Focused Equity',
                fundCategoryName: 'Equity',
                fundCategory: {
                    entityId: '1',
                    name: 'Equity',
                    shortName: null,
                    fullName: null,
                    sortOrder: null,
                },
                inceptionDate: '2008-02-15',
                mer: 0.01,
                currency: 'CAD',
                fundCodes: {
                    nl: 'SUN466',
                },
                productName: 'No Product',
                productGroupSortOrder: 0,
            },
            performance: {
                dailyPerformance: {
                    effectiveDate: '2023-01-17',
                    navPS: 66.8223,
                    price: null,
                    d1EffectiveDate: '2023-01-16',
                    d1NavPs: 66.6176,
                    d1Amt: 0.2047,
                    d1Pct: 0.003072761552502642,
                    d1Price: null,
                },
                effectiveDate: '2022-12-31',
                compoundPerformance: {
                    effectiveDate: '2022-12-31',
                    p1mo: -0.0527889099520813,
                    p3mo: 0.0624636827141273,
                    p6mo: 0.0548439168448335,
                    pytd: -0.0873916121242886,
                    p1yr: -0.0873916121242886,
                    p2yr: 0.04552099978375,
                    p3yr: 0.06446361868871,
                    p4yr: 0.10046632064745,
                    p5yr: 0.06992675633838,
                    p7yr: 0.07985035460102,
                    p8yr: 0.07280234109722,
                    p9yr: 0.07824601547741,
                    p10yr: 0.09147133294727,
                    psi: 0.0543058459556147,
                    psiB1: null,
                    psiB2: null,
                    psiB3: null,
                    best3mo: 0.277995347853669,
                    best3moEffectiveDate: '2009-05-29',
                    worst3mo: -0.322074867543774,
                    worst3moEffectiveDate: '2008-11-28',
                },
            },
            morningStarSeriesRatings: {
                overAllRating: {
                    rating: 4,
                    numFund: 540,
                },
                _1moRating: {
                    rating: null,
                    numFund: null,
                },
                _3moRating: {
                    rating: null,
                    numFund: null,
                },
                _6moRating: {
                    rating: null,
                    numFund: null,
                },
                _1yrRating: {
                    rating: null,
                    numFund: 555,
                },
                _3yrRating: {
                    rating: 3,
                    numFund: 540,
                },
                _5yrRating: {
                    rating: 4,
                    numFund: 495,
                },
                _10yrRating: {
                    rating: 4,
                    numFund: 321,
                },
                effectiveDate: '2022-12-31',
            },
            relatedDocuments: [
                {
                    entityId: 'MBEGF-CAD-FF',
                    code: 'FF',
                    name: 'Fund Facts',
                    shortName: 'Fund Facts',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-prod-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-prod-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-sit-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-sit-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-staging-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-FP-staging-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-MRFP',
                    code: 'MRFP',
                    name: 'Management Reports of Fund Performance',
                    shortName: 'MRFP',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-prod-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-prod',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-sit-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-sit',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-staging-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-PC-staging',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-Prospectus',
                    code: 'Prospectus',
                    name: 'Simplified Prospectus and Annual Information Form',
                    shortName: 'Prospectus',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBEGF-CAD-QPD',
                    code: 'QPD',
                    name: 'Quarterly Portfolio Disclosure',
                    shortName: 'QPD',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
            ],
        },
        {
            entityId: 'MBFCAA-CAD',
            sortOrder: null,
            isInactive: null,
            overview: {
                fundName: 'Sun Life MFS Canadian Bond Fund',
                seriesName: 'Series A',
                webProfileFundName: null,
                seriesShortName: 'A',
                seriesSortOrder: 80,
                aum: 140238190.73,
                riskRatingName: 'Low',
                riskRating: {
                    entityId: '1',
                    name: 'Low',
                    sortOrder: '001',
                },
                assetClass: 'Canadian Fixed Income',
                assetClassSortOrder: 80,
                cifscCategory: 'Canadian Fixed Income',
                fundCategoryName: 'Fixed income',
                fundCategory: {
                    entityId: '2',
                    name: 'Fixed income',
                    shortName: null,
                    fullName: null,
                    sortOrder: null,
                },
                inceptionDate: '2009-03-31',
                mer: 0.0129,
                currency: 'CAD',
                fundCodes: {
                    isc: 'SUN174',
                    dsc: 'SUN274',
                    lsc: 'SUN374',
                },
                productName: 'No Product',
                productGroupSortOrder: 0,
            },
            performance: {
                dailyPerformance: {
                    effectiveDate: '2023-01-17',
                    navPS: 12.6133,
                    price: null,
                    d1EffectiveDate: '2023-01-16',
                    d1NavPs: 12.6064,
                    d1Amt: 0.0069,
                    d1Pct: 0.0005473410331260312,
                    d1Price: null,
                },
                effectiveDate: '2022-12-31',
                compoundPerformance: {
                    effectiveDate: '2022-12-31',
                    p1mo: -0.0174912082397752,
                    p3mo: 0.00260036109684359,
                    p6mo: 0.00529880023081715,
                    pytd: -0.133043399919871,
                    p1yr: -0.133043399919871,
                    p2yr: -0.082603337982681,
                    p3yr: -0.030461362504753,
                    p4yr: -0.006619547189638,
                    p5yr: -0.007454434918383,
                    p7yr: 0.00054206049327,
                    p8yr: 0.00171372032166,
                    p9yr: 0.01069640281847,
                    p10yr: 0.00795484676066,
                    psi: 0.020567813776559,
                    psiB1: null,
                    psiB2: null,
                    psiB3: null,
                    best3mo: 0.0856105986391892,
                    best3moEffectiveDate: '2020-06-30',
                    worst3mo: -0.0757873093577509,
                    worst3moEffectiveDate: '2022-04-29',
                },
            },
            morningStarSeriesRatings: {
                overAllRating: {
                    rating: 2,
                    numFund: 469,
                },
                _1moRating: {
                    rating: null,
                    numFund: null,
                },
                _3moRating: {
                    rating: null,
                    numFund: null,
                },
                _6moRating: {
                    rating: null,
                    numFund: null,
                },
                _1yrRating: {
                    rating: null,
                    numFund: 526,
                },
                _3yrRating: {
                    rating: 2,
                    numFund: 469,
                },
                _5yrRating: {
                    rating: 1,
                    numFund: 400,
                },
                _10yrRating: {
                    rating: 3,
                    numFund: 249,
                },
                effectiveDate: '2022-12-31',
            },
            relatedDocuments: [
                {
                    entityId: 'MBFCAA-CAD-FF',
                    code: 'FF',
                    name: 'Fund Facts',
                    shortName: 'Fund Facts',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-prod-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-prod-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-sit-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-sit-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-staging-public',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-FP-staging-secure',
                    code: 'FP',
                    name: 'Fund Profile',
                    shortName: 'Investor fact sheet',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'fp-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-MRFP',
                    code: 'MRFP',
                    name: 'Management Reports of Fund Performance',
                    shortName: 'MRFP',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-prod-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-prod',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-prod',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-sit-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-sit',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-sit',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-staging-secure',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-secure-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-PC-staging',
                    code: 'PC',
                    name: 'Product Category URL',
                    shortName: null,
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'pc-public-staging',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-Prospectus',
                    code: 'Prospectus',
                    name: 'Simplified Prospectus and Annual Information Form',
                    shortName: 'Prospectus',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
                {
                    entityId: 'MBFCAA-CAD-QPD',
                    code: 'QPD',
                    name: 'Quarterly Portfolio Disclosure',
                    shortName: 'QPD',
                    url: '/',
                    title: null,
                    description: null,
                    thumbnailUrl: null,
                    tags: 'documents',
                    sortOrder: null,
                },
            ],
        },
    ],
    annotations: [
        {
            id: 'overviewMerValueAnnotation',
            text: "management expenses ratio as of {{format feesDate 'CompactDate'}}",
            textHtml: null,
            textTargetId: null,
            markerTargetId: 'merValue',
            markerType: null,
            marker: '*',
        },
        {
            id: 'overviewNetAssetsAnnotation',
            text: 'All Series Combined',
            textHtml: null,
            textTargetId: 'disclaimers',
            markerTargetId: 'aumValue',
            markerType: null,
            marker: '†††',
        },
        {
            id: 'tmif1000',
            text: 'this is fund specific qpd text 2',
            textHtml: 'this is fund specific qpd text-html 2',
            textTargetId: 'intro',
            markerTargetId: null,
            markerType: null,
            marker: null,
        },
    ],
    theme: '',
    themeSelected: '',
    colorSpace: 'rgb',
};
